import React from 'react';
import { Route, Switch } from 'react-router-dom';
import NoAccess from './noaccess';
import SessionExpired from './session-expired';
import UnAuthorize from './unauthorize';
import NotFound from './not-found';

const Error = () => {
    return (
        <Switch>
            <Route exact path='/error/noaccess' component={NoAccess} />
            <Route exact path='/error/sessionexpired' component={SessionExpired} />
            <Route exact path='/error/unauthorized' component={UnAuthorize} />
            <Route path='*' exact={true} component={NotFound} />
        </Switch>
    );
}

export default Error;